'use es6';

import Immutable from 'immutable';
import { ALL_COLLECTIONS_COLLECTION_FETCH_RECEIVED, ALL_COLLECTIONS_COLLECTION_FETCH_FAILED, ALL_COLLECTIONS_COLLECTION_FETCH_REQUESTED } from './ActionTypes';
import * as ecosystemClient from '../clients/ecosystemClient';
import { ALL_COLLECTIONS_LENGTH } from '../constants';
import * as FilterKey from '../constants/search/FilterKey';
import * as SortField from '../constants/search/SortField';
import * as StorefrontCollection from '../constants/StorefrontCollection';
import StorefrontFilters from '../records/StorefrontFilters';
import { getTotalDisplayedCollectionListings } from '../selectors/collections';
import { maybeEarlyRequest, getAllCollectionsEarlyRequestName } from '../utils/earlyRequests';
import { getLangCode } from '../selectors/auth';
let allCollectionsQueryMap = Immutable.Map();

const getTotalSearchLength = totalCollections => totalCollections * ALL_COLLECTIONS_LENGTH;

const getAllCollectionsQuery = (collection, totalCollections) => {
  if (!allCollectionsQueryMap.has(collection)) {
    let sortField;

    if (collection === StorefrontCollection.POPULAR) {
      sortField = SortField.HUB_INSTALLS;
    } else if (collection === StorefrontCollection.NEW) {
      sortField = SortField.FIRST_PUBLISHED;
    } else {
      sortField = SortField.RANDOM;
    }

    const filters = new StorefrontFilters({
      [FilterKey.COLLECTION]: collection,
      [FilterKey.SORT_FIELD]: sortField
    });
    const query = filters.toSearchQuery({
      length: sortField === SortField.RANDOM ? getTotalSearchLength(totalCollections) : ALL_COLLECTIONS_LENGTH
    });
    allCollectionsQueryMap = allCollectionsQueryMap.set(collection, query);
  }

  return allCollectionsQueryMap.get(collection);
};

export const fetchCollectionResult = (collectionId, isLegacyCollection) => (dispatch, getState) => {
  const state = getState();
  const language = getLangCode(state);
  const totalCollections = getTotalDisplayedCollectionListings(state);
  const earlyRequestName = getAllCollectionsEarlyRequestName(collectionId);
  dispatch({
    type: ALL_COLLECTIONS_COLLECTION_FETCH_REQUESTED,
    meta: {
      collectionId
    }
  });
  const request = isLegacyCollection ? maybeEarlyRequest(earlyRequestName, () => {
    const query = getAllCollectionsQuery(collectionId, totalCollections);
    return ecosystemClient.searchApps({
      language,
      queries: [query]
    });
  }).then(response => response.results[0]) : ecosystemClient.fetchCollectionItems(collectionId, {
    length: getTotalSearchLength(totalCollections),
    language
  });
  return request.then(result => {
    dispatch({
      type: ALL_COLLECTIONS_COLLECTION_FETCH_RECEIVED,
      payload: result,
      meta: {
        collectionId
      }
    });
    return result;
  }).catch(error => {
    dispatch({
      type: ALL_COLLECTIONS_COLLECTION_FETCH_FAILED,
      payload: error,
      meta: {
        collectionId
      }
    });
    throw error;
  });
};